<template>
    <div class="form-group currency-picker">
        <label class="form-label section-title">{{ $t('messages.currency_title') }}</label>
        <div class="currency-control">
            <select class="form-select" v-model="localCurrency" @change="updateCurrency" :disabled="locked">
                <option v-for="currency in availableCurrencies" :key="currency.currency" :value="currency.currency">
                    {{ $t(`messages.currencies.${currency.currency}`) }} ({{
                        $t(`messages.currency_symbols.${currency.currency}`) }})
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: "Currency",
    props: {
        currency: {
            type: String,
            default: 'USD'
        },
        locked: {
            type: Boolean,
            default: false
        },
        currencies: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            localCurrency: this.currency
        };
    },
    computed: {
        availableCurrencies() {
            // ensure KZT is present and first
            const hasKzt = (this.currencies || []).some(c => c.currency === 'KZT');
            if (hasKzt) return this.currencies;
            return [{ currency: 'KZT' }, ...this.currencies];
        }
    },
    watch: {
        currency(newValue) {
            this.localCurrency = newValue;
        },
        // locked watcher removed — don't overwrite currency when control is locked,
        // the parent should provide the correct currency via the `currency` prop.
    },
    methods: {
        updateCurrency() {
            this.$emit('update', this.localCurrency);
        }
    }
};
</script>

